export const pp_accreditationFormDefaultValuesUpdate = {
  accreditationForm: {
    affiliatedOrganization: '',
    fullName: '',
    forename: '',
    surname: '',
    subCategory: null,
    jobTitle: '',
    coachType: '',
    dateOfBirth: new Date(),
    agreeToTermsAndConditions: false,
    nominatedForDinner: false,
    emailAddress: '',
    mobile: '',
    mobileCode: '',
    accDocumentFile: null,
    contactImageFile: null,
    lockAsReadonly: true,
  },
  currentChampionshipId: '',
  accreditationFormKontentItemCodename: '',
};
